import { INELIGIBLE_ZIPS_8_28_2025 } from './zips';

export const INELIGIBLE_ZIPS = [INELIGIBLE_ZIPS_8_28_2025];

/**
 * Combines various business zipcode lists that should not be eligible for lead submissions,
 * and then checks if they contain the given zipcode.
 */
export const isIneligibleLeadZip = (zip: number): boolean => {
  return INELIGIBLE_ZIPS.flat().find((z) => z === zip) !== undefined;
};
